import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=533b6a8e&scoped=true&"
var script = {}
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=533b6a8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b6a8e",
  null
  
)

export default component.exports